<template>
  <v-row>
    <v-col md="12" cols="12">
      <v-card elevation="2">
        <v-card-text>
          <h3>Mapas de departamento</h3>
          <v-alert
            v-if="areas.length > 0"
            outlined
            type="warning"
            dense
            border="left"
          >
            La edición del área de mesas afectara en tiempo real la operacion
            del restaurante.
          </v-alert>
          <v-btn
            @click="$router.push({ path: '/restaurante/departamentos' })"
            color="red"
            dark
          >
            <span class="hidden-sm-and-down">Regresar</span>
          </v-btn>
          <v-btn>
            <span class="hidden-sm-and-down" @click="showModal = true"
              >Agregar Mapa</span
            >
          </v-btn>
        </v-card-text>
      </v-card>
    </v-col>
    <v-col md="12" cols="12">
      <v-card elevation="2">
        <v-card-text>
          <v-alert
            v-if="areas.length == 0"
            color="blue-grey"
            dark
            dense
            icon="mdi-silverware-fork-knife"
          >
            Agregue un área al departamento seleccionado, agregue mesas, sillas
            y otros elementos al mapa de restaurante.
          </v-alert>
          <v-row
            v-if="loadingData"
            class="fill-height"
            align-content="center"
            justify="center"
          >
            <v-col class="subtitle-1 text-center" cols="12">
              Cargando información
            </v-col>
            <v-col cols="6">
              <v-progress-linear
                color="deep-purple accent-4"
                indeterminate
                rounded
                height="6"
              ></v-progress-linear>
            </v-col>
          </v-row>
          <v-tabs v-if="areas.length > 0">
            <template v-for="(area, index) in areas">
              <v-tab :key="index">
                {{ area.Nombre }}
              </v-tab>
            </template>
            <template v-for="(area, index) in areas">
              <v-tab-item :key="index">
                <v-card flat>
                  <v-card-text>
                    <floorRestaurant
                      :editable="true"
                      :roomData="area"
                      @deleteArea="deleteArea"
                      @updateArea="updateArea"
                    />
                  </v-card-text>
                </v-card>
              </v-tab-item>
            </template>
          </v-tabs>
        </v-card-text>
      </v-card>
    </v-col>
    <modal ref="modalForm" v-model="showModal" :showFooter="false">
      <v-form ref="roleForm">
        <v-text-field
          v-model="Nombre"
          :rules="rules.name"
          label="Nombre área"
          outlined
          dense
          required
        ></v-text-field>
        <div class="text-right">
          <v-btn large @click="showModal = false">Cancelar</v-btn>
          <v-btn
            style="margin-left: 6px"
            color="success"
            large
            @click="createArea()"
            >Guardar</v-btn
          >
        </div>
      </v-form>
    </modal>
  </v-row>
</template>

<style></style>

<script>
import modal from "../MainComponents/modal.vue";
import floorRestaurant from "../MainComponents/floorRestaurant.vue";

export default {
  name: "DepartamentoAreaEditor",
  components: { floorRestaurant, modal },
  props: [],
  data() {
    return {
      loadingData: false,
      Nombre: null,
      areas: [],
      showModal: false,
      rules: {
        name: [(value) => value || "El nombre es obligatorio"],
      },
    };
  },
  methods: {
    createArea() {
      let datos = {
        Nombre: this.Nombre,
        Mapa: { Mapa: [], Ancho: 8, Alto: 8 },
        Ancho: 8,
        Alto: 8,
        Departamento: this.$route.params.idDepartamento,
      };

      this.$swal({
        title: "¿Deseas guardar la información del área?",
        text: "El área se almacenará y podrá empezar a usarse",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Guardar",
        showLoaderOnConfirm: true,
        allowOutsideClick: false,
        preConfirm: async () => {
          return await this.$store.getters.getFirebaseApp.fba
            .call("AYB-Areas-createArea", datos)
            .then(function (result) {
              return result;
            })
            .catch((error) => {
              this.$swal.showValidationMessage(`Request failed: ${error}`);
            });
        },
      }).then((result) => {
        if (result.value) {
          if (result.value.data.ok) {
            this.$pgsHelper.log(result.value);
            this.$swal({
              title: "Guardado",
              text: "El área se guardó correctamente",
              icon: "success",
            }).then(() => {
              this.areas.push(result.value.data.data);
              this.showModal = false;
            });
          } else {
            this.$swal("Error saving área", result.value.data.error, "error");
          }
        }
      });
    },
    updateArea(data) {
      data.Departamento = this.$route.params.idDepartamento;

      this.$swal({
        title: "¿Deseas modificar la información del área?",
        text: "El área se almacenará y podrá empezar a usarse",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Guardar",
        showLoaderOnConfirm: true,
        allowOutsideClick: false,
        preConfirm: async () => {
          return await this.$store.getters.getFirebaseApp.fba
            .call("AYB-Areas-updateArea", data)
            .then(function (result) {
              return result;
            })
            .catch((error) => {
              this.$swal.showValidationMessage(`Request failed: ${error}`);
            });
        },
      }).then((result) => {
        if (result.value) {
          if (result.value.data.ok) {
            this.$pgsHelper.log(result.value);
            let areaData = this.$pgsHelper.getById(this.areas, "Id", data.Id);
            this.areas[areaData.idx].Mapa = result.value.data.data;

            this.$swal({
              title: "Guardado",
              text: "El área se guardó correctamente",
              icon: "success",
            }).then(() => {
              /*this.areas.push({Id:"23432432",Nombre:this.Nombre});*/
              this.showModal = false;
            });
          } else {
            this.$swal("Error saving área", result.value.data.error, "error");
          }
        }
      });
    },
    deleteArea(data) {
      data.Departamento = this.$route.params.idDepartamento;
      this.$swal({
        title: "¿Deseas eliminar la información del área?",
        text: "El área se eliminara permanentemente",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Eliminar",
        showLoaderOnConfirm: true,
        allowOutsideClick: false,
        preConfirm: async () => {
          return await this.$store.getters.getFirebaseApp.fba
            .call("AYB-Areas-deleteArea", data)
            .then(function (result) {
              return result;
            })
            .catch((error) => {
              this.$swal.showValidationMessage(`Request failed: ${error}`);
            });
        },
      }).then((result) => {
        if (result.value) {
          if (result.value.data.ok) {
            this.$pgsHelper.log(result.value);
            let areaData = this.$pgsHelper.getById(this.areas, "Id", data.Id);
            this.areas.splice(areaData.idx, 1);
            this.$swal({
              title: "Eliminado",
              text: "El área se elimino correctamente",
              icon: "success",
            }).then(() => {
              this.showModal = false;
            });
          } else {
            this.$swal("Error saving área", result.value.data.error, "error");
          }
        }
      });
    },
    async getAreas() {
      this.loadingData = true;
      let Areas = [];
      let snapshot =
        await this.$store.getters.getFirebaseApp.database.queryBuilder(
          "AYB/Areas/" + this.$route.params.idDepartamento
        );
      if (snapshot.exists()) {
        Areas = [];
        Object.keys(snapshot.val()).forEach((id) => {
          const toAdd = snapshot.val()[id];
          if (toAdd) {
            toAdd.Id = id;
            Areas.push(toAdd);
          }
        });
      }

      const firestore = this.$store.getters.getFirebaseApp.firestore;

      const data = await firestore.queryBuilder("AYB_Mapas", [
        firestore.where(
          "Departamento",
          "==",
          this.$route.params.idDepartamento
        ),
        firestore.where(
          "Tenant",
          "==",
          this.$store.getters.getFirebaseApp.tenant
        ),
      ]);

      let dataMapas = data.docs.map((doc) => {
        return { Id: doc.ref.id, ...doc.data() };
      });

      Areas.forEach((area) => {
        dataMapas.forEach((mapa) => {
          if (mapa.Area == area.Id) {
            area.Mapa = mapa;
          }
        });
      });
      this.loadingData = false;
      this.areas = Areas;
    },
  },
  computed: {},
  watch: {},
  mounted() {},
  created() {
    this.getAreas();
  },
};
</script>
